import Vuex from 'vuex'
import Vue from 'vue'
import {Base64} from 'js-base64';

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {},
  state: {
    nav: 'home',
    userInfo:{
      nickname:"昵称"
    }
  },
  mutations: {
    changeNav (state, path) {
      state.nav = path.replace(/\//g, '')
      console.log(state.nav)
    },
    setUserInfo(state){
      if (!window.$cookies.get("token")){
        return;
      }
      let info = JSON.parse(Base64.decode(window.$cookies.get("token").split(".")[1]))
      state.userInfo.imgurl=info.img_url;
      console.log(info)
      state.userInfo.nickname=info.nickname;
    }
  },
  actions: {},
  getters: {
    getUserInfo(state){
      return state.userInfo
    }
  }
})

